export default __webpack_public_path__ + "static/media/PngItem_6781246.8b9e72e3.png";